<template>
	<v-select
		:filterable="false"
		:options="assessments"
		@search="searchAssessments"
		label="name"
		@input="emitAssessment"
		:value="value"
		:multiple="multiple"
		:placeholder="placeholder"
		:disabled="disabled"
	>
		<template slot="no-options">
			<span>Type to search assessments...</span>
		</template>

		<template slot="option" slot-scope="option">
			<div class="d-flex flex-row align-items-center">
				<span class="flex">{{ option.name }}</span>
				<span class="text-muted">{{ option.ref_id }}</span>
			</div>
			<div>
				<span v-for="grade in option.grades" :key="grade.id" class="badge theme-accent mr-1">{{
					grade.name
				}}</span>
				<span v-for="(standard, i) in option.standards" :key="i" class="badge success mr-1">{{
					standard
				}}</span>
				<span v-for="(essential_skill, i) in option.essential_skills" :key="i" class="badge danger mr-1">{{
					essential_skill
				}}</span>
			</div>
			<div v-html="option.description" class="text-xxs text-muted height-limit">No Description</div>
		</template>

		<template slot="selected-option" slot-scope="option">
			<div class="d-flex flex-row align-items-center">
				<span class="flex">
					{{ option.name }}
					<span v-if="option.ref_id">
						•
						<span v-html="option.description" class="text-muted">No Description</span>
					</span>
				</span>
			</div>
		</template>
	</v-select>
</template>

<style scoped>
.height-limit {
	max-height: 2.5em;
	overflow: hidden;
	text-overflow: ellipsis;
}
.align-fix {
	margin-top: -3px;
}
</style>

<script>
import AssessmentService from "@/services/AssessmentService";
import fs from "@/services/FormatService";

export default {
	name: "ConfigAssessmentSearch",

	props: {
		value: true,
		placeholder: true,
		contentAreas: true,
		grades: true,
		multiple: {
			type: Boolean,
			default: false
		},
		disabled: true
	},

	components: {},

	data() {
		return {
			fs: fs,
			assessments: []
		};
	},
	created() {},
	watch: {},
	computed: {
		contentAreaIDs() {
			return _.map(this.contentAreas, "id");
		},
		gradeIDs() {
			return _.map(this.grades, "id");
		}
	},
	methods: {
		searchAssessments(search, loading) {
			loading(true);
			let ctx = {
				active: true,
				perPage: 8,
				currentPage: 1,
				active: true,
				cas: this.contentAreaIDs,
				grades: this.gradeIDs,
				filter: search
			};

			AssessmentService.listAssessments(ctx)
				.then(resp => {
					this.assessments = resp.data.assessments;

					loading(false);
				})
				.catch(err => {
					console.log(err);
					this.assessments = [{ name: "Error loading assessments" }];
				});
		},

		emitAssessment(assessment) {
			if (!assessment) {
				this.assessments = [];
			}
			this.$emit("input", assessment);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/ConfigAssessmentSearch.vue